import React from 'react';
import { Check, ShieldCheck, Zap } from 'lucide-react';
export function HeroSection() {
  const handleScrollToOffer = (e: React.MouseEvent) => {
    e.preventDefault();
    const offerSection = document.getElementById('offer-section');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative bg-warm-50 pb-12 md:pb-20 overflow-hidden" data-id="element-65">
      {/* Promo Banner */}
      <div className="w-full bg-accent text-white py-2 px-4 text-center font-bold md:text-base text-[18px] tracking-wide shadow-sm relative z-20" data-id="element-66">
        ¡Compra el Ebook y recibe un recetario gratis!
      </div>

      <div className="max-w-6xl mx-auto px-4 pt-8 md:pt-16 relative z-10" data-id="element-67">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-16" data-id="element-68">
          {/* Text Content */}
          <div className="flex-1 text-center md:text-left order-1 md:order-1" data-id="element-69">
            <h1 className="md:text-5xl lg:text-6xl font-black mb-6 text-[42px] leading-[1.15] font-[Montserrat,_sans-serif] text-[#1A1A1A]" data-id="element-70">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary via-[#ff7e27] to-accent drop-shadow-sm" data-id="element-71">
                Sabor colombiano real
              </span>
              <br className="hidden md:block" data-id="element-72" />
              <span data-id="element-73"> en 15 minutos.</span>
            </h1>

            <p className="text-lg md:text-xl text-charcoal-muted mb-8 font-medium leading-relaxed" data-id="element-74">
              Comida típica real en minutos: tiempos y grados exactos para tu
              Airfryer.
            </p>

            {/* Mobile Image (shows only on mobile, between text and bullets) */}
            <div className="md:hidden w-full max-w-sm mx-auto mb-10 order-2 relative group perspective-1000" data-id="element-75">
              <div className="absolute inset-0 bg-gradient-to-tr from-primary/30 to-accent/30 rounded-full blur-2xl transform scale-90" data-id="element-76"></div>
              <img src="https://cdn.magicpatterns.com/uploads/pyv6jdzNBshoQ6ZB1oDtP4/IMAGEN_PRODUCTO.png" alt="Airfryer a la Colombiana eBook Mockup" className="w-full h-auto relative z-10 transform -rotate-2 hover:rotate-0 transition-transform duration-500 drop-shadow-[0_20px_30px_rgba(232,93,4,0.35)]" loading="eager" data-id="element-77" />
            </div>

            <ul className="space-y-4 mb-10 text-left max-w-lg mx-auto md:mx-0 order-3 md:order-2" data-id="element-78">
              <li className="flex items-start gap-3 bg-white/50 p-3 rounded-xl border border-warm-100" data-id="element-79">
                <div className="bg-trust/10 p-1.5 rounded-full shrink-0" data-id="element-80">
                  <Check className="w-4 h-4 text-trust" data-id="element-81" />
                </div>
                <span className="text-charcoal font-semibold mt-0.5" data-id="element-82">
                  Tiempos exactos para que te quede crocante (por fin)
                </span>
              </li>
              <li className="flex items-start gap-3 bg-white/50 p-3 rounded-xl border border-warm-100" data-id="element-83">
                <div className="bg-accent/10 p-1.5 rounded-full shrink-0" data-id="element-84">
                  <Zap className="w-4 h-4 text-accent" data-id="element-85" />
                </div>
                <span className="text-charcoal font-semibold mt-0.5" data-id="element-86">
                  Truco de limpieza express en 3 minutos (sin restregar grasa)
                </span>
              </li>
              <li className="flex items-start gap-3 bg-white/50 p-3 rounded-xl border border-warm-100" data-id="element-87">
                <div className="bg-trust/10 p-1.5 rounded-full shrink-0" data-id="element-88">
                  <Check className="w-4 h-4 text-trust" data-id="element-89" />
                </div>
                <span className="text-charcoal font-semibold mt-0.5" data-id="element-90">
                  Ajustes por marcas comunes en Colombia
                </span>
              </li>
            </ul>

            <div className="flex flex-col items-center md:items-start order-4 md:order-3" data-id="element-91">
              <button onClick={handleScrollToOffer} className="w-full md:w-auto bg-primary hover:bg-primary-hover text-white font-heading font-black text-lg md:text-xl py-4 px-10 rounded-xl shadow-[0_8px_25px_-5px_rgba(232,93,4,0.5)] hover:shadow-[0_15px_35px_-5px_rgba(232,93,4,0.6)] hover:-translate-y-1 transition-all duration-300 uppercase tracking-wide h-16 flex items-center justify-center gap-2" data-id="element-92">
                Quiero mi recetario ya
              </button>

              <p className="text-xs md:text-sm text-charcoal-muted mt-4 font-bold" data-id="element-93">
                Pago único • Acceso de por vida • Entrega inmediata por email
              </p>

              {/* Secure Payment Section - Fixed Layout */}
              <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-4 mt-8 bg-white/80 backdrop-blur-sm px-6 py-4 rounded-xl border border-warm-200 shadow-sm w-full max-w-md mx-auto md:mx-0" data-id="element-94">
                <div className="flex items-center gap-2" data-id="element-95">
                  <ShieldCheck className="w-6 h-6 text-trust shrink-0" data-id="element-96" />
                  <span className="text-sm font-bold text-charcoal leading-tight text-center sm:text-left" data-id="element-97">
                    Pago seguro con
                    <br className="hidden sm:block" data-id="element-98" /> encriptación SSL
                  </span>
                </div>

                <div className="hidden sm:block w-px h-10 bg-warm-200" data-id="element-99"></div>
                <div className="block sm:hidden w-full h-px bg-warm-200" data-id="element-100"></div>

                <div className="flex items-center gap-4" data-id="element-101">
                  <img src="https://cdn.magicpatterns.com/uploads/2zdbbb26BSMiNAeyqHDwW3/logo_visa.jpg" alt="Visa" className="h-6 object-contain mix-blend-multiply" data-id="element-102" />
                  <img src="https://cdn.magicpatterns.com/uploads/1ArHwTfNzfjXzKbbSYuN4r/logo_pse.png" alt="PSE" className="h-6 object-contain mix-blend-multiply" data-id="element-103" />
                  <img src="https://cdn.magicpatterns.com/uploads/jRnFN63dEodrYuMtDVqYt5/logo_nequi.png" alt="Nequi" className="h-6 object-contain mix-blend-multiply" data-id="element-104" />
                </div>
              </div>
            </div>
          </div>

          {/* Desktop Image */}
          <div className="hidden md:block flex-1 order-2 relative group perspective-[1000px]" data-id="element-105">
            <div className="absolute inset-0 bg-gradient-to-tr from-primary/20 to-accent/20 rounded-full blur-3xl transform -translate-y-10 scale-110 group-hover:scale-125 transition-transform duration-700" data-id="element-106"></div>
            <img src="https://cdn.magicpatterns.com/uploads/pyv6jdzNBshoQ6ZB1oDtP4/IMAGEN_PRODUCTO.png" alt="Airfryer a la Colombiana eBook Mockup" className="w-full h-auto relative z-10 transform -rotate-3 hover:rotate-0 hover:-translate-y-2 transition-all duration-500 drop-shadow-[0_25px_45px_rgba(232,93,4,0.4)]" loading="eager" data-id="element-107" />
          </div>
        </div>
      </div>
    </section>;
}